/**
 *
 */
export enum CO2UnitRateLabel {
    Kg = "kg/kWh",
    Lb = "lb/kWh",
}